import axios from '../axios/index';
import axiosNomal from 'axios';
const commonAccessKey = ['localhost:9909', 'test-b2b.10jqka.com.cn'].includes(window.location.host) ? 'dfc5f04a453d8918' : '587c51e645db43cd';
const query = require('querystring');
export function detailPage(params) {
  return axios.get('https://b2b-news.10jqka.com.cn/hxcota/cloud-info/getInfoDetail', {
    params: {
      ...params,
      accessKey: commonAccessKey,
    },
  });
}
export function materialDetailPage(params) {
  const { accessKey, ...restParams } = params;
  return axios.get('https://b2b-news.10jqka.com.cn/hxcota/cloud/get_info_detail', {
    params: {
      ...restParams,
      accessKey: accessKey || commonAccessKey,
    },
  });
}
export function deepInsight(params) {
  return axios.get('https://b2b-news.10jqka.com.cn/hxcota/info/page/v1/deepInsight', {
    params
  });
}
export function eventTrack(params) {
  return axiosNomal.post('/info-search/analysis/point.do', {
    ...params,
    accessKey: commonAccessKey,
  });
}

// 公告列表
export function affiche_list(params) {
  return axios.get('/market/stocks/notice/v1/list', {
    params
  });
}
// 大事提醒
export function event_list(params) {
  return axios.get('/event/remind/v2/list', {
    params
  });
}
// 大事提醒页签接口
export function event_tabs(params) {
  return axios.get('/event/remind/cate', {
    params
  });
}
/**
 * @description 详情页接口
 * @params accessKey 券商id
 * @params id 资讯id
 * @params type 资讯类型 sc新闻， sr研报, sn公告
 * @params needContent 是否需要正文 1需要 0不需要
 */
export function afficheDetail(params) {
  return axios.get('/market/stocks/stock/detail', {
    params: {
      needContent: '1',
      ...params
    }
  });
}
// 卖空明细
export function sale_list(params) {
  return axios.get('/ggsale/v1/detail', {
    params
  });
}
export function weixinApi(params) {
  return axios.post('/broker/getSignature', query.stringify({
    ...params,
    accessKey: commonAccessKey,
  }));
}
